import { createContext, useContext, useState } from "react"

export const CardsContext = createContext()

export const useCards = () => useContext(CardsContext)

export const CardsProvider = ({ children }) => {
    const [cards, setCards] = useState([])
    const [selectedCard, setSelectedCard] = useState()

    return (
        <CardsContext.Provider
            value={{
                cards,
                setCards,
                selectedCard,
                setSelectedCard
            }}
        >
            {children}
        </CardsContext.Provider>
    )
}

export default CardsProvider
